import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {
    NatBikeParkingUseChangeApplyInfo,
    NatResidentBikeParkingUseChangeApplyLocationState,
} from './NatResidentApplicationInterface'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import NatResidentBikeParkingUseChangeApplyConfirm from './resident/NatResidentBikeParkingUseChangeApplyConfirm'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {NatPutBikeParkingUseChangeApplyResponse} from '../repository/NatPutBikeParkingUseChangeApply'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    condominiumRepo: NatCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<NatResidentBikeParkingUseChangeApplyLocationState>
}

class NatResidentBikeParkingUseChangeApplyConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const locationState: NatBikeParkingUseChangeApplyInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName, applicantFirstName, useArea, changeType,
            changeStartDate, changeEndDate, userFamilyName, userFirstName, userAttribute,
            ownerFamilyName, ownerFirstName, bikeType, bikeName,
            bikeRegistrationNumber, engineSize,
        } = locationState

        const request = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            useArea: useArea,
            changeType: changeType,
            changeStartDate: changeStartDate,
            changeEndDate: changeEndDate,
            userFamilyName: userFamilyName,
            userFirstName: userFirstName,
            userAttribute: userAttribute,
            ownerFamilyName: ownerFamilyName,
            ownerFirstName: ownerFirstName,
            bikeType: bikeType,
            bikeName: bikeName,
            bikeRegistrationNumber: bikeRegistrationNumber,
            engineSize: engineSize,
            confirmed: true,
        }

        try {
            const response: Nullable<NatPutBikeParkingUseChangeApplyResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyBikeParkingUseChangeApply.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentBikeParkingUseChangeApplyLocationState = this.props.location.state
        this.props.navigate(`/resident/condominiums/${this.props.condominiumCd}/applications/bikeParkingUsesChange/input`, {
            replace: true,
            state: JSON.parse(JSON.stringify(locationState)),
        })
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentBikeParkingUseChangeApplyConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>修正する</CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentBikeParkingUseChangeApplyConfirmPage)
